import React, { useEffect, useState } from "react";

import { Button, Tooltip } from "antd";

import EditCommunityListComponent from "./community/EditCommunityListComponent";
// import EditCommunityLonglifeWriteComponent from "./community/EditCommunityLonglifeWriteComponent";
import EditCommunityWriteComponent from "./community/EditCommunityWriteComponent";

const EditCommunity = () => {
	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	const [communityWriteShow, setCommunityWriteShow] = useState(false);
	const [selectCommunity, setSelectCommunity] = useState({});

	const makeNewCommunity = () => {
		setCommunityWriteShow(!communityWriteShow);
		setSelectCommunity({});
	};

	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<div
				className={`edit-profile-channel`}
				style={
					mediaResult
						? {
								alignItems: "flex-start",
								justifyContent: "flex-start",
								width: "100%",
								margin: "auto",
								flexDirection: "column",
								gap: "1.5em",
						  }
						: {
								alignItems: "flex-start",
								justifyContent: "flex-start",
								width: "75%",
								margin: "auto",
								flexDirection: "column",
								gap: "1.5em",
						  }
				}
			>
				{!communityWriteShow ? (
					<div className={`edit-community-title`}>
						<p className={`title`}>글 목록</p>
						<Button
							className={`edit-community-write-button`}
							size={`small`}
							onClick={makeNewCommunity}
						>
							글 작성하기
						</Button>
					</div>
				) : (
					<div
						className={`edit-community-title`}
						style={{
							justifyContent: "flex-start",
							gap: "10px",
						}}
					>
						{selectCommunity?.id ? (
							<p className={`title`}>글 수정하기</p>
						) : (
							<p className={`title`}>글 작성하기</p>
						)}
						<Tooltip
							trigger={mediaResult ? "click" : "hover"}
							title={"복사해서 붙여넣기한 글의 색상과 굵기처리만 반영됩니다."}
							overlayStyle={{
								whiteSpace: "pre-wrap",
								wordBreak: "keep-all",
							}}
							overlayInnerStyle={{
								textAlign: "center",
							}}
						>
							<img
								src={`/assets/images/report/notice.png`}
								alt={`세금 안내`}
								style={{
									height: "1.6em",
									width: "auto",
									cursor: "pointer",
								}}
							/>
						</Tooltip>
					</div>
				)}

				{!communityWriteShow ? (
					<EditCommunityListComponent
						mediaResult={mediaResult}
						setCommunityWriteShow={setCommunityWriteShow}
						selectCommunity={selectCommunity}
						setSelectCommunity={setSelectCommunity}
					/>
				) : (
					<EditCommunityWriteComponent
						setCommunityWriteShow={setCommunityWriteShow}
						selectCommunity={selectCommunity}
					/>
				)}
			</div>
		</div>
	);
};
export default EditCommunity;
